export default function Footer() {
  return (
    <div className="footer">
      <small className="copyright">
        &copy; <span>{new Date().getFullYear()}</span>.Digix
      </small>
    </div>
  );
}
